require('./bootstrap');
require('datatables.net-bs5');